import React from "react"
import PropTypes from "prop-types"
import flow from "lodash/flow"
import has from "lodash/has"
import { SubmissionError } from "redux-form"
import { translate } from "react-i18next"
import withStyles from "@material-ui/core/styles/withStyles"

import { validateSubmit as validate } from "./validate"
import LayoutLogin from "../../lib/views/LayoutLogin/LayoutLogin"
import LoginForm from "./LoginForm"
import TwoFactorAuthForm from "./TwoFactorAuthForm"
import connect from "./connect"
import styles from "./styles"

export class RouteLogin extends React.Component {
    handleSubmitLogin = (formData) => {
        const { emailChecked, doSsoCheck, doLogin } = this.props
        const errors = validate(formData)

        if (has(errors, "username")) {
            throw new SubmissionError({ username: errors.username })
        }

        if (has(errors, "password") && emailChecked && emailChecked === formData.username) {
            throw new SubmissionError(errors)
        }

        if (formData.username && emailChecked === formData.username) {
            return doLogin(formData)
        }

        return doSsoCheck({ email: formData.username })
    }

    handleSubmitTwoFactor = (formData) => {
        const { submitTwoFactorAuthentication } = this.props
        submitTwoFactorAuthentication(formData)
    }

    render() {
        const {
            emailChecked, onEmailChanged, requires2FA, logout,
        } = this.props

        return (
            <LayoutLogin backFunc={requires2FA ? logout : null}>
                {requires2FA ? (
                    <TwoFactorAuthForm
                        onSubmit={this.handleSubmitTwoFactor}
                        handleBackButton={logout}
                    />
                ) : (
                    <LoginForm
                        onSubmit={this.handleSubmitLogin}
                        isEmailChecked={!!(emailChecked)}
                        onEmailChanged={onEmailChanged}
                    />
                )}
            </LayoutLogin>
        )
    }
}

RouteLogin.propTypes = {
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    doLogin: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    onEmailChanged: PropTypes.func.isRequired,
    doSsoCheck: PropTypes.func.isRequired,
    submitTwoFactorAuthentication: PropTypes.func.isRequired,
    emailChecked: PropTypes.string,
    requires2FA: PropTypes.bool,
}

RouteLogin.defaultProps = {
    emailChecked: null,
    requires2FA: false,
}

export default flow([
    connect,
    translate(),
    withStyles(styles),
])(RouteLogin)
